"use client";
import React, { memo } from "react";
import {
  Box,
  LinearProgress,
  LinearProgressProps,
  Stack,
  Typography,
} from "@mui/material";

const AppProgressBarUpload = ({
  value,
  fileName,
  isShowProgress,
  ...otherProps
}: AppProgressBarUploadProps) => {
  return (
    <Stack alignItems="center" width="100%">
      <Stack justifyContent="space-between" width="100%" direction="row">
        <Typography>{fileName}</Typography>
        {isShowProgress && (
          <Typography variant="body2" color="text.secondary">{`${Math.round(
            value
          )}%`}</Typography>
        )}
      </Stack>
      {isShowProgress && (
        <Box sx={{ width: "100%" }}>
          <LinearProgress value={value} variant="determinate" {...otherProps} />
        </Box>
      )}
    </Stack>
  );
};

type AppProgressBarUploadProps = LinearProgressProps & {
  value: number;
  fileName: string;
  isShowProgress?: boolean;
};

export default memo(AppProgressBarUpload);
